import { getEnv } from "../../../../utils/env"
import React, { Component } from "react"
import { format } from "date-fns"
import { SUPPORT_EMAIL } from "../../../mp-core/constants"
import loginLetterHeaderSvg from "./login-letter-header.svg?raw"

// The header image is embedded once, in the stylesheet, and painted on every
// page by this rule. Inlining it in an <img> on every page cost ~35 KB per
// student, which is what broke DocRaptor on large imports. The url() is
// unquoted because React escapes quotes inside <style>; `100% 100%` matches
// the old <img height="250" width="100%"> stretch. Buffer (UTF-8) rather than
// btoa, which throws on any character above U+00FF.
const LOGIN_LETTER_HEADER_STYLE = `.csv-page .login-letter-header { height: 250px; width: 100%; background-repeat: no-repeat; background-size: 100% 100%; background-image: url(data:image/svg+xml;base64,${Buffer.from(loginLetterHeaderSvg).toString("base64")}) }`

const PageView = ({ student, districtName, stateName }) => {
  return (
    <div className="new-page vertical-content csv-page">
      <div
        className="login-letter-header"
        role="img"
        aria-label="WorkKeys Curriculum Logo"
      />
      <section className="csv-text">
        <div className="date">{format(new Date(), "MMMM d, yyyy")}</div>
        <div className="student-name">
          {student.firstName} {student.lastName},
        </div>
        <div>
          <p>
            Welcome to ACT WorkKeys Curriculum! The purpose of this platform is
            to provide access to career-relevant course that will help you level
            up your skills.
          </p>
          <p>
            <strong>Visit:</strong>{" "}
            <a href={`https://workkeys.masteryprep.com`}>
              workkeys.masteryprep.com
            </a>
          </p>
          {student.email && !student.password ? (
            <p>
              We sent a message to your email address,{" "}
              <strong>{student.email}</strong>, with information about how to
              create your password and sign in to your account. If you don’t see
              it in your inbox, please check your spam folder.
            </p>
          ) : (
            <div>
              {!student.email && (
                <p>
                  <strong>Click</strong>{" "}
                  <a href={`https://workkeys.masteryprep.com/signin-username`}>
                    “Log in using your username”
                  </a>
                </p>
              )}
              {!student.email ? (
                <React.Fragment>
                  <p>
                    <strong>State: </strong>
                    {stateName}
                  </p>
                  <p>
                    <strong>Institution District: </strong>
                    {districtName}
                  </p>
                  <p>
                    <strong>Username: </strong>
                    {student.username}
                  </p>
                </React.Fragment>
              ) : (
                <p>
                  <strong>E-mail: </strong>
                  {student.email}
                </p>
              )}
              {((student.email && student.password) || student.username) && (
                <p>
                  <strong>Password: </strong>
                  {student.password || student.username}
                </p>
              )}
            </div>
          )}
          <p>
            Login to the platform with the credentials we provided. There you
            can access your courses and progress through the skills.
          </p>
          <p>
            If you are unsure of how to log in or if you have difficulties
            accessing your account, please ask your instructor for assistance.
            They will be able to help you with the issue. We know this program
            will help you build the work skills you need. We look forward to
            seeing your progress.
          </p>
          <p>
            <div>Best of luck,</div>
            <div>MasteryPrep</div>
            <strong>{SUPPORT_EMAIL}</strong>
          </p>
        </div>
      </section>
    </div>
  )
}

export default class ImportCSVPrintTemplate extends Component {
  render() {
    const { students, districtName, stateName } = this.props
    return (
      <html lang="en">
        <head>
          <meta charSet="UTF-8" />
          <title>{`WorkKeys Curriculum Invite Letter`}</title>
          <link
            rel="stylesheet"
            href={`${getEnv("DOMAIN")}/pdf-export-doc-raptor-css/main.css`}
            type="text/css"
          />
          <style>{LOGIN_LETTER_HEADER_STYLE}</style>
          <link
            href="https://fonts.googleapis.com/css?family=Bitter|Open+Sans:400,700"
            rel="stylesheet"
          />
          <link
            rel="stylesheet"
            href="https://use.fontawesome.com/releases/v5.0.10/css/all.css"
            integrity="sha384-+d0P83n9kaQMCwj8F4RJB66tzIwOKmrdb46+porD/OvrJ+37WqIM7UoBtwHO6Nlg"
            crossOrigin="anonymous"
          />
        </head>
        <body>
          {students.map((student, key) => (
            <PageView
              student={student}
              districtName={districtName}
              stateName={stateName}
              key={key}
            />
          ))}
        </body>
      </html>
    )
  }
}
